import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let appointment_id = useDataValue({
    context: 'appointment_overlay',
    path: 'appointment_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      appointment_id,
    },
    requestPolicy: 'network-only',
    pause: !appointment_id || appointment_id === 'new',
  }
}
